var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import * as Dinamic from '@ali/dinamic/build';
import template from '@ali/dinamic-template';
import '@ali/dinamic-views';
var mock = {
    tpl: template("<?xml version=\"1.0\" encoding=\"utf-8\"?>\n  <DFrameLayout xmlns:dinamic=\"http://schemas.android.com/apk/res-auto\"\n    xmlns:ios=\"http://schemas.android.com/apk/res-auto\"\n    dinamic:dHeight=\"20ap\"\n    dinamic:dWidth=\"50ap\"\n    dinamic:dBackgroundColor=\"#00ff00\">\n    <DTextView\n      dText=\"$data{ext.text}\"\n      dMarginTop=\"10\"\n      dTextColor=\"#ff00ff\"\n      dLinked=\"origin_text\"\n    />\n  </DFrameLayout>"),
    data: {
        ext: {
            text: 'It works well.'
        }
    },
};
var CardDynamic = (function (_super) {
    __extends(CardDynamic, _super);
    function CardDynamic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardDynamic.prototype.render = function () {
        return (React.createElement(Dinamic.Template, { tpl: mock.tpl, data: mock.data }));
    };
    return CardDynamic;
}(React.Component));
export default CardDynamic;

//# sourceMappingURL=index.js.map
